import { render } from "./Administrator.vue?vue&type=template&id=ccdf51ba&ts=true"
import script from "./Administrator.vue?vue&type=script&lang=ts"
export * from "./Administrator.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomas/Workspace/SushiEden/SushiEden.Admin.Vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__